import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { ClientAdminService } from 'src/app/business-service/client-admin/client-admin.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UserAccessComponent } from './user-access/user-access.component';
import { GlobalService } from '../../shared/services/global/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';


@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent implements OnInit {
  @ViewChild(UserDetailsComponent) UserDetailsComponent!: UserDetailsComponent;
  @ViewChild(UserAccessComponent) UserAccessComponent!: UserAccessComponent;


  userId: any;
  orderOftabs: string[] = ['userdetails', 'useraccess'];
  orderOfTabsIndex: number = 0;
  componentView: string = this.orderOftabs[this.orderOfTabsIndex];


  entireUserDetails: any;
  userDetailsData: any;
  userAcessData: any;


  @Input() targetTab: string = 'userdetails'


  editUserId: any;
  organizationType: string = '';


  constructor(
    private _modalServices: ModalsService,
    private _modalController: ModalController,
    private _clientService: ClientAdminService,
    private _reloadService: ComponentReloadService,
    private _globalService: GlobalService,
    private _router: Router,
    private _activeRoute: ActivatedRoute,
    private _responseNotificationService: ResponseNotificationService
  ) { }


  ngOnInit() {
    if (this.editUserId) {
      this._clientService.getUser(this.editUserId).subscribe(data => {
        this.userId = data.userId;
        this.entireUserDetails = data;
        this.assignUserDetails();
      });


    }
    if (this.targetTab) {
      this.setTab(this.targetTab); // Activate the correct tab based on the passed targetTab
    }


  }




  setTab(tab: string) {
    const tabIndex = this.orderOftabs.indexOf(tab);
    if (tabIndex !== -1) {
      this.orderOfTabsIndex = tabIndex;
      this.componentView = this.orderOftabs[tabIndex];
    }
  }


  closeModal() {
    this._modalController.dismiss();
  }


  async onViewChangeFromTab(view: string) {
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction(
        "You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed"
      );
      switch (res) {
        case 'saveProceed': {
          if (await this.saveDataOfCurrentForm(this.componentView)) {
            this.viewChangeFromTab(view);
          }
          break;
        }
        case 'proceed': {
          this.viewChangeFromTab(view);
          break;
        }
      }
    } else {
      this.viewChangeFromTab(view);
    }
  }
  checkCurrentFormDirty(view: any): any {
    switch (view) {
      case 'userdetails': {
        return this.UserDetailsComponent?.formDataModified();
      }
      case 'useraccess': {
        return this.UserAccessComponent?.formDataModified();
      }
      default: {
        return false;
      }
    }
  }


  async saveDataOfCurrentForm(view: any) {
    switch (view) {
      case 'userdetails': {
        return this.UserDetailsComponent?.onSubmit();
      }
      case 'useraccess': {
        return this.UserAccessComponent?.onSubmit();
      }
      default: {
        return false;
      }
    }
  }


  reloadAllChildComponents() {
    this.UserDetailsComponent?.ngOnInit();
    this.UserAccessComponent?.ngOnInit();
  }


  viewChangeFromTab(view: string) {
    this.componentView = view;
    this.orderOfTabsIndex = this.orderOftabs.indexOf(view);


  }


  async onViewChnage(goPrevious: any) {
    if (goPrevious) {
      this.orderOfTabsIndex--;
      this.componentView = this.orderOftabs[this.orderOfTabsIndex];
    } else {
      this.orderOfTabsIndex++;
      this.componentView = this.orderOftabs[this.orderOfTabsIndex];
    }
  }


  // user id passing
  assignUserId(userId: any) {
    this.userId = userId;
  }


  // edit
  patchUserDetailsValues(formData: any) {
    this.userDetailsData = {
      ...formData,
      dataSaved: true
    }
  }
  patchUserAccess(formData: any) {
    this.userAcessData = {
      ...formData,
      dataSaved: true
    }
  }


  serializeUser(profileImgPath: boolean = false) {
    const data = {
      userDetail: {
        ...this.userDetailsData,
        imagePath: profileImgPath ? this.userDetailsData.imagePath : null,
      },
      userAccess: this.userAcessData || null,
      id: this.entireUserDetails?.id || null,
      userId: this.entireUserDetails?.userId || null,
      ownershipRole: this.entireUserDetails?.ownershipRole,
      organizationId: this.entireUserDetails?.organizationId || null,
      organizationType: this.entireUserDetails?.organizationType
    }
    return data;
  }

  async onSubmit(profileImgPath: boolean = false): Promise<boolean> {
    const formData = this.serializeUser(profileImgPath);
    if (this.editUserId) {
      return new Promise((resolve) => {
        this._clientService.updateUser(this.editUserId, formData).subscribe({
          next: async (data: any) => {
            // Assign each tab details here
            this.entireUserDetails = data;
            this.assignUserId(data.userId);
            this.assignUserDetails();
            this._reloadService.triggerUsersReload();
            this.reloadAllChildComponents();
          },
          error: (error) => {
            console.error('Error updating User: ', error);
            this._responseNotificationService.showMessage("Error updating User", true);
            resolve(false);
          },
          complete: () => {
            this._responseNotificationService.showMessage("User updated successfully");
            this._reloadService.triggerOrganizationReload();
            resolve(true);
          }
        });
      });
    } else {
      return new Promise((resolve) => {
        this._clientService.addUserDetails(formData).subscribe({
          next: async (data: any) => {
            this.entireUserDetails = data;
            this.assignUserId(data.userId);
            this.editUserId = data.userId;
            this.assignUserDetails();
            this._reloadService.triggerUsersReload();
            this.reloadAllChildComponents();
          },
          error: (error) => {
            console.error('Error saving organization: ', error);
            this._responseNotificationService.showMessage("Error saving User", true);
            resolve(false);
          },
          complete: () => {
            this._responseNotificationService.showMessage("User added successfully");
            this._reloadService.triggerOrganizationReload();
            resolve(true);
          }
        });
      });
    }
  }

  assignUserDetails() {
  this.userDetailsData = {
    ...this.entireUserDetails.userDetail,
    userId: this.entireUserDetails.userId  // ✅ correctly spread userId into userDetailsData
  };
  this.userAcessData = this.entireUserDetails.userAccess;
  this.makeAllTabsGreen();
}

  makeAllTabsGreen() {
    if (this.userDetailsData) {
      this.userDetailsData.dataSaved = true;
    }
    if (this.userAcessData) {
      this.userAcessData.dataSaved = true;
    }
  }


  showReview() {
    this.closeModal();
    this._router.navigate([`/client-admin/user-details/${this.userId}`]);
  }
}



